'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import Select from 'react-select';
import { connect } from 'react-redux';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { labVal } from '@/state/utilities';

import s from './styles.scss';

const sx = cn.bind(s);

class Page extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			showMenu: false,
			oldPassphrase: '',
			newPassphrase: '',
			settings: {
				workWeek: {
					options: [
						'Monday—Friday',
						'Tuesday—Saturday',
						'Wednesday—Sunday',
						'Thursday—Monday',
						'Friday—Tuesday',
						'Saturday—Wednesday',
						'Sunday—Thursday',
					].map(labVal),
					value: [ 'Monday—Friday' ].map(labVal)[ 0 ],
				}
			}
		};

		if (props.user) {
			const userWorkWeek = props.user.settings.workWeek;
			this.state.settings.workWeek.value = [ userWorkWeek ].map(labVal)[ 0 ];
		}

		[
			'toggleMenu',
			'onOldPassphraseChange',
			'onNewPassphraseChange',
			'onWorkWeekChange',
			'postSettings',
		].forEach(fn => { this[fn] = this[fn].bind(this) });
	}

	componentDidMount() {

		const {
			user,
			username,
			fetchUser,
		} = this.props;


		if (!user) {
			fetchUser(username);
		}
	}

	componentDidUpdate(prevProps) {

		const { user } = this.props;

		if (user && !prevProps.user) {
			const { settings } = this.state;
			const { workWeek } = settings;
			const userWorkWeek = user.settings.workWeek;

			this.setState({ settings: {
				...settings,
				workWeek: {
					...workWeek,
					value: [ userWorkWeek ].map(labVal)[ 0 ]
				}
			}});
		}
	}

	toggleMenu() {
		const { showMenu } = this.state;

		this.setState({ showMenu: !showMenu });
	}

	onOldPassphraseChange(e) {

		const oldPassphrase = e.target.value.replace(/^\s+|\s+$/g,'');
		this.setState({ oldPassphrase });
	}

	onNewPassphraseChange(e) {

		const newPassphrase = e.target.value.replace(/^\s+|\s+$/g,'');
		this.setState({ newPassphrase });
	}

	onWorkWeekChange(selected) {

		const { settings } = this.state;
		const { workWeek } = settings;
		workWeek.value = selected;
		this.setState({ settings: { ...settings, workWeek }});
	}

	postSettings() {

		const { username, postSettings } = this.props;
		const { oldPassphrase, newPassphrase, settings } = this.state;
		const { workWeek } = settings;

		const readySettings = {
			settings: {
				workWeek: workWeek.value.value
			}
		};

		if (newPassphrase) {
			readySettings.oldPassphrase = oldPassphrase;
			readySettings.newPassphrase = newPassphrase;
		}

		postSettings(username, readySettings);
	}

	render() {

		const { username, user } = this.props;
		const { showMenu, oldPassphrase, newPassphrase, settings } = this.state;
		const { workWeek } = settings;

		if (!user) {
			return <div />;
		}

		return (
			<div className={ s.root }>
				<form className={ s.form }>
					<div className={ s.rows }>
					<div className={ s.settingRow }>
						<label>Old Passphrase</label>
						<span className={ s.formCont }>
							<input
								type='password'
								onChange={ this.onOldPassphraseChange }
								value={ oldPassphrase }
							/>
						</span>
					</div>
					<div className={ s.settingRow }>
						<label>New Passphrase</label>
						<span className={ s.formCont }>
							<input
								type='password'
								onChange={ this.onNewPassphraseChange }
								value={ newPassphrase }
							/>
						</span>
					</div>
					<div className={ s.settingRow }>
						<label>Work Week</label>
						<span className={ s.formCont }>
							<Select
								onChange={ this.onWorkWeekChange }
								options={ workWeek.options }
								value={ workWeek.value }
								isClearable={ false }
							/>
						</span>
					</div>
					</div>
				</form>
				<button
					type='submit'
					className={ s.submit }
					onClick={ this.postSettings }
				>
					Save
				</button>
			</div>
		);
	}
}

const Main = connect(
	(state, props) => ({
		user: usersSelectors.getPageUser(state, props),
		username: usersSelectors.getUsername(state, props),
	}),
	{
		fetchUser: usersOperations.fetchUser,
		postSettings: usersOperations.postSettings,
	}
)(Page);

export const components = {
	main: Main,
};

export default Main;
